var exports = {
  "kL": "x61f99309--4513d4--container",
  "oO": "x61f99309--4513d4--container_iframe_desktop",
  "jb": "x61f99309--4513d4--companion",
  "l3": "x61f99309--4513d4--back_button",
  "NC": "x61f99309--4513d4--action_buttons",
};

module.exports = exports;
